module.exports = __webpack_public_path__ + "img/boblogosmall.1c06cce2.png";